import { useRentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { HAS_SEEN_FEATURE_TOUR_TAG } from '../../../constants/InvalidateConstants';

import type { RentalManagerUserTrackingEvent } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type UseHasSeenFeatureTourOptions = Omit<
  RentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour_Options,
  'queryKey' | 'queryFn'
>;

export const useHasSeenFeatureTour = (
  featureTourTrackingEvent: RentalManagerUserTrackingEvent,
  options: UseHasSeenFeatureTourOptions = {},
) => {
  const { meta: metaOverrides, enabled = true, ...restOptions } = options;

  const { data, error, isFetching, isPending } = useRentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour(
    { featureTourTrackingEvent },
    {
      ...restOptions,
      enabled: Boolean(featureTourTrackingEvent) && enabled,
      meta: {
        ...metaOverrides,
        tags: [HAS_SEEN_FEATURE_TOUR_TAG, featureTourTrackingEvent, ...(metaOverrides?.tags ?? [])],
        context: {
          api: 'useRentalManagerUserTrackingV2WebApiHandler_hasSeenFeatureTour',
          details: 'useHasSeenFeatureTour',
          ...metaOverrides?.context,
        },
      },
    },
  );

  return { data, error, isFetching, isPending };
};
